export enum QualityGoalStatus {
    PENDING = 'pending',
    INVALID = 'invalid',
    EVIDENCE_REQUIRED = 'evidenceRequired',
    DONE = 'done',
}
